import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 10 класс",
        subject: "Виды информации в тексте",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Виды информации в тексте",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Трушина Маргарита Дмитриевна",
                grade: "лаборант лаборатории филологического общего образования ФГБНУ «Институт стратегии развития образования»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>При работе с текстом учащиеся могут сталкиваться со следующими трудностями: верное определение микротем, различение главной и второстепенной информации, выделение информации, выраженной в тексте эксплицитно и на уровне подтекста. Знание о наличии в тексте разных видов информации и сформированные умения выделять виды информации в тексте помогает понять текст, создать на его основе вторичный текст.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В раскрытии данной темы учителю необходим чёткий алгоритм действий, который поможет учащимся выделять информацию и классифицировать ее. Важно учитывать стилевую принадлежность текстов и разный уровень их сложности: сформированные умения должны быть переносимы на тексты любой функциональной разновидности языка.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Усвоение темы «Виды информации в тексте» способствует формированию читательской грамотности и навыков осмысленного чтения. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В рамках данного кейса учитель получит ответы на следующие вопросы: Как способствовать освоению обучающимися умений выявления информации в тексте? Как научить анализировать и комментировать основную и дополнительную, явную и скрытую информацию текстов? Какие тексты выбирать для анализа?</p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Александрова О.М., Аристова М.А., Васильевых И.П. и др.; под ред. Добротиной И.Н. Читательская грамотность школьника (5–9 классы): книга для учителя — М.: Российский учебник; Вентана-Граф, 2018. — 144 с.",
                "Александрова О.М., Добротина И.Н., Гостева Ю.Н., Васильевых И.П., Ускова И.В. Работа с текстом на уроке русского языка: пособие для учителя. 5–11 классы. ФГОС. — М.: Экзамен»; ФГБНУ «Институт стратегии развития образования РАО», 2019. — 159 с.",
                "Бахтин М.М. Эстетика словесного творчества. М.: Искусство, 1986.",
                "Ванюшина Н.Р. Методика работы с текстовой информацией на уроке литературы. Электронный ресурс. ",
                "Васильев С.А. Синтез смысла при создании и понимании текста. Киев, 1988.",
                "Выготский Л.С. Мышление и речь. М.: Лабиринт, 1999.",
                "Гальперин. И.Р. Текст как объект лингвистического исследования.—М.: Наука,. 1981. 138 с.",
                "Гаспаров Б.М. Язык. Память. Образ. Лингвистика языкового существования. М.: Новое литературное обозрение, 1996.",
                "Граник Г.Г. Восприятие школьниками художественного текста. – Вопросы психологии, 1996, №3.",
                "Граник Г.Г., Концевая Л.А., Бондаренко С.М. О реализации закономерностей понимания в учебном тексте. – В книге: Проблемы школьного учебника. Выпуск 20. М., 1991.    ",
                "Ипполитова Н.А. Текст в системе изучения русского языка в школе. / Н.А. Ипполитова. — М., 1998. — 176 с. ",
                "Соболева О.В. О понимании мини-текста. – Вопросы  психологии, 1995, №1."
            ],
            filesToDownload: [
                {
                    link: "./files/additional_1.pdf",
                    fileName: "Таблица с классификацией видов информации и словами-маркерами разновидностей дополнительной информации"
                },
                {
                    link: "./files/additional_2.pdf",
                    fileName: "Тексты для отработки выявления основной и дополнительной информации"
                },
                {
                    link: "./files/additional_3.pdf",
                    fileName: "Алгоритм заполнения читательской карты для выявления информации в тексте и классификации её по видам"
                },
                {
                    link: "./files/additional_4.pdf",
                    fileName: "Тексты для отработки выявления фактологической, подтекстовой и концептуальной информации (в порядке возрастания сложности)"
                }
            ]
        }
    ],
};
